import isBlockedPaywall from './isBlockedPaywall';

export default isBlockedPaywall;
